<template>
    <validation-observer ref="form" v-slot="{ handleSubmit, meta }">
        <modal
            :id="modalId"
            :title="title"
            scrollable
            ok-title="Save"
            :ok-disabled="!meta.valid || loading"
            @ok.prevent="handleSubmit(_, save)"
            @hide="hideModal"
        >
            <busy-modal :show="loading"></busy-modal>
            <b-form @submit.prevent="handleSubmit(_, save)" v-if="values">
                <b-row>
                    <b-col>
                        <validation-provider name="name" v-slot="{ errors, handleChange }" rules="required" >
                            <form-input label="Name:" v-model="values.name" :error="errors[0]" @input="handleChange"></form-input>
                        </validation-provider>
                    </b-col>
                </b-row>
            </b-form>
        </modal>
    </validation-observer>
</template>

<script>
    import isEmpty from 'lodash/isEmpty';
    import { formatResponseError } from '../../../utils/api';
    import BusyModal from '../../generic/busy-modal/busy-modal.vue';
    import FormInput from '../../generic/form-input/form-input.vue';
    import Modal from '../../generic/modal/modal.vue';

    export default {
        name: 'DashboardDetailsModalForm',
        components: {
            BusyModal,
            FormInput,
            Modal,
        },
        props: {
            modalId: String,
            create: {
                type: Function,
                default: () => Promise.resolve(),
            },
            update: {
                type: Function,
                default: () => Promise.resolve(),
            },
            initialValues: {
                type: Object,
                default: () => ({}),
            },
        },
        computed: {
            title() {
                return this.values && this.values.id ? 'Edit Dashboard' : 'Create Dashboard';
            },
        },
        data() {
            return {
                loading: false,
                values: null,
            };
        },
        mounted() {
            this.values = this.getInitialValues();
        },
        methods: {
            getInitialValues() {
                return {
                    id: this.initialValues.id || null,
                    name: this.initialValues.name || '',
                };
            },
            hideModal() {
                this.$bvModal.hide(this.modalId);
            },
            async save() {
                this.loading = true;

                try {
                    if (this.values.id) {
                        const response = await this.update(this.values);
                        this.$emit('success-update', response.data);
                    } else {
                        const response = await this.create(this.values);
                        this.$emit('success-create', response.data);
                    }
                    this.$nextTick(() => {
                        this.hideModal();
                    });
                } catch (err) {
                    const { generic, fields } = formatResponseError(err);

                    if (generic) {
                        this.errorToast({ text: generic });
                    }
                    if (!isEmpty(fields)) {
                        this.$refs.form.setErrors(fields);
                    }
                } finally {
                    this.loading = false;
                }
            },
        },
        watch: {
            initialValues() {
                this.values = this.getInitialValues();
            },
        },
    };
</script>
